import { render } from "./BreakDown.vue?vue&type=template&id=40e48461&scoped=true"
import script from "./BreakDown.vue?vue&type=script&lang=js"
export * from "./BreakDown.vue?vue&type=script&lang=js"

import "./BreakDown.vue?vue&type=style&index=0&id=40e48461&scoped=true&lang=css"
import "./BreakDown.vue?vue&type=style&index=1&id=40e48461&lang=scss&scoped=true"
import "@/assets/css/essayWriting.sass?vue&type=style&index=2&id=40e48461&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e48461"]])

export default __exports__